import { mixpanelService } from '@/lib/services/mixpanel/initializeMixPanel'
import { isProductPageUrl } from '@/lib/services/mixpanel/helpers/isProductPageUrl'
import { MixpanelEvent } from '../mixpanelEvent'

type BannerClickEventProps = {
  eventLocation: string
  topBannerName: string
  linkUrl: string
}

export const trackBannerClick = async ({
  eventLocation,
  topBannerName,
  linkUrl,
}: BannerClickEventProps) => {
  const linkType = isProductPageUrl(linkUrl) ? 'product_page' : 'products_page'

  await mixpanelService.trackEvent(MixpanelEvent.TOP_BANNER_CLICKED, {
    event_location: eventLocation,
    top_banner_name: topBannerName,
    full_url: linkUrl,
    link_type: linkType,
  })
}
